<template>
    <div>
    <Header></Header>
    <Login></Login>
    <!-- <div class="banner"></div> -->
    <img class="banner" src="../assets/images/aboutUs/关于我们banner@2x.png" alt="">
    <div class="aboutUs-content">
        <div class="aboutUs-content-wrapper">
          <div class="aboutUs-content-left">
            <div class="title">关于我们</div>
            <div class="enTitle">About Us</div>
            <img src="../assets/images/businessCooperation/装饰元素1@2x.png" alt="">
           </div>
           <div class="aboutUs-content-right">
               <div class="info1">
                    <span>澜城数据</span>由上海澜思信息科技有限公司于2005年创立，是中国首批房地产市场信息数据公司之一。
               </div>
               <div class="info2">自成立，澜城数据专注于上海房地产行业数据的收集、整理和分析入手，到对行业成长前景的深刻思考，都坚定以帮助房地产企业可持续性发展作为我们的永恒课题。</div>
               <div class="info3">我们在以第一手市场信息数据为基础，结合IT信息技术，成功研发出的“RES房地产数据系统”科技产品，在业内得到了广泛的认可和赞誉。在房地产信息服务行业中，面临迭代和创新，我们近年来行业细分、下沉服务，分别面向开发商机构、中介机构、估价机构研发【城图】、【小房书】等专业系统及定制化数据服务。</div>
               <div class="info4">新时代，我们不忘初心，将自己定位为房地产企业可持续性发展的重要合作伙伴，不仅为房地产企业提供专业的房地产行业市场咨询服务，未来将以城市发展的动态监测为发展方向，以满足中国房企在构建美丽城市的适时需求。</div>
            </div>
        </div>
    </div>
    <div class="dev-history">
        <div class="title">发展历程</div>
        <div class="enTitle">Development Path</div>
        <div class="aim">
            <img src="../assets/images/aboutUs/装饰元素2@2x.png" alt="">
            <div class="aim-text">专注上海房地产行业数据收集、整理和分析</div>
        </div>
        <div class="year-level">
            <div class="year-level-wrapper">
                <div class="num-all">
                    <img class="img-2020" src="../assets/images/aboutUs/2020@2x.png" alt="">
                    <img class="img-2018" src="../assets/images/aboutUs/2018@2x.png" alt="">
                    <img class="img-2017" src="../assets/images/aboutUs/2017@2x.png" alt="">
                    <img class="img-2016" src="../assets/images/aboutUs/2016@2x.png" alt="">
                    <img class="img-2015" src="../assets/images/aboutUs/2015@2x.png" alt="">
                    <img class="img-2014" src="../assets/images/aboutUs/2014@2x.png" alt="">
                    <img class="img-2013" src="../assets/images/aboutUs/2013@2x.png" alt="">
                    <img class="img-2012" src="../assets/images/aboutUs/2012@2x.png" alt="">
                    <img class="img-2011" src="../assets/images/aboutUs/2011@2x.png" alt="">
                </div>
                <div class="line-all">
                    <div class="line2020">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point1.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2018">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point2.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2017">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point1.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2016">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point2.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2015">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point1.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2014">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point2.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2013">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point1.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2012">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point2.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="line2011">
                        <img width="16px" height="16px" src='../assets/images/aboutUs/point1.png' />
                        <div class="line"></div>
                        <div class="dot"></div>
                    </div>
                </div>
                <div class="month-all">
                    <div class="month-all-list">
                        <div class="month-list-item" v-for="(item,index) in monthList" :key="index">
                            <div class="month"><span class="enMonth">{{item.enMonth}}</span><span class="chMonth">{{item.chMonth}}</span></div>
                            <div class="month-text">{{item.monthText}}</div>
                        </div>

                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  components: {
    Header,
    Footer,Login
  },
  data() {
    return {
      monthList: [
        {
          enMonth: "Jan",
          chMonth: "一月",
          monthText: "行业细分，下沉服务"
        },
        {
          enMonth: "Jul",
          chMonth: "七月",
          monthText: "RAS房价跟踪系统升级"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "小房书产品上市"
        },
        {
          enMonth: "Dec",
          chMonth: "十二月",
          monthText: "城图-房地产检测研究系统上市"
        },
        {
          enMonth: "Jan",
          chMonth: "一月",
          monthText: "恒星小区指数发布"
        },
        {
          enMonth: "Aug",
          chMonth: "八月",
          monthText: "深度合作，健全模式"
        },
        {
          enMonth: "Oct",
          chMonth: "十月",
          monthText: "WES房价跟踪系统上市"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "建立标准，个性服务"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "拓展市场，研发新品"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "团队完善"
        },
        {
          enMonth: "Nov",
          chMonth: "十一月",
          monthText: "楼盘数据库上市"
        },
        {
          enMonth: "May",
          chMonth: "五月",
          monthText: "产品升级，技术创新"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "联系客户，选择产品"
        },
        {
          enMonth: "Mar",
          chMonth: "三月",
          monthText: "打通渠道，组建团队"
        },
        {
          enMonth: "Jun",
          chMonth: "六月",
          monthText: "整合资源，建数据库"
        },
        {
          enMonth: "Dec",
          chMonth: "十二月",
          monthText: "RES房地产数据分析系统上市"
        }
      ]
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: auto;
  display: block;
  // height: 240px;
  // background: url("../assets/images/aboutUs/关于我们banner@2x.png") no-repeat;
  // background-size: 100% 100%;
}

.aboutUs-content {
  width: 100%;
  padding: 56px 0;
  background: #fff;

  .aboutUs-content-wrapper {
    width: 1140px;
    height: 308px;
    margin: 0 auto;
    overflow: hidden;

    .aboutUs-content-left {
      width: 367px;
      height: 308px;
      float: left;

      .title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #272727;
        line-height: 40px;
      }

      .enTitle {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 22px;
        letter-spacing: 2px;
        position: relative;

        &::after {
          content: "";
          width: 64px;
          height: 2px;
          background: #3880f4;
          position: absolute;
          bottom: -16px;
          left: 0;
        }
      }

      img {
        width: 139px;
        height: 66px;
        display: block;
        margin-top: 122px;
      }
    }

    .aboutUs-content-right {
      width: 773px;
      height: 308px;
      float: left;

      .info1,
      .info2,
      .info3,
      .info4 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #272727;
        line-height: 28px;

        span {
          color: #3880f4;
          font-weight: 600;
          font-family: PingFangSC-Medium, PingFang SC;
        }
      }

      .info2,
      .info4 {
        margin: 30px 0;
      }
    }
  }
}

.dev-history {
  background: #fafbfc;
  padding-top: 56px;
  position: relative;

  .title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #272727;
    line-height: 40px;
  }

  .enTitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999;
    text-align: center;
    line-height: 22px;
    letter-spacing: 2px;
    position: relative;
  }

  .aim {
    width: 288px;
    height: 122px;
    position: absolute;
    top: 230px;
    left: 240px;

    img {
      width: 221px;
      height: 105px;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .aim-text {
      width: 198px;
      height: 72px;
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #272727;
      line-height: 36px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 99;
    }
  }

  .year-level {
    width: 1140px;
    height: 1970px;
    margin: 0 auto;
    margin-top: 56px;

    .year-level-wrapper {
      width: 520px;
      height: 1970px;
      margin: 0 auto;
      position: relative;
    }

    .num-all {
      width: 44px;
      height: 1970px;
      position: absolute;
      top: 0;
      left: 0;

      .img-2020,
      .img-2018,
      .img-2017,
      .img-2016,
      .img-2015,
      .img-2014,
      .img-2013,
      .img-2012,
      .img-2011 {
        width: 44px;
        height: 26px;
        display: block;
        position: absolute;
        top: 0;
        left: 150px;

        &.img-2018 {
          top: 470px;
        }
        &.img-2017 {
          top: 820px;
        }
        &.img-2016 {
          top: 942px;
        }
        &.img-2015 {
          top: 1060px;
        }
        &.img-2014 {
          top: 1295px;
        }
        &.img-2013 {
          top: 1412px;
        }
        &.img-2012 {
          top: 1528px;
        }
        &.img-2011 {
          top: 1646px;
        }
      }
    }

    .line-all {
      .line2020 {
        width: 16px;
        height: 463.5px;
        margin: 0 auto;
        position: relative;

        .circular {
          width: 13px;
          height: 13px;
          border-radius: 50%;
          border: 1px solid #3880f4;
          position: relative;

          .dot {
            width: 4px;
            height: 4px;
            background: #3880f4;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .line {
          width: 1px;
          height: 443px;
          background: #3880f4;
          margin: 0 auto;
        }
        .dot {
          width: 4px;
          height: 4px;
          background: #3880f4;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .line2018 {
        width: 16px;
        height: 345.5px;
        margin: 0 auto;
        margin-top: 8px;
        position: relative;

        .circular {
          width: 13px;
          height: 13px;
          border-radius: 50%;
          border: 1px solid #f8b062;
          position: relative;

          .dot {
            width: 4px;
            height: 4px;
            background: #f8b062;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .line {
          width: 1px;
          height: 324px;
          background: #f8b062;
          margin: 0 auto;
        }
        .dot {
          width: 5px;
          height: 5px;
          background: #f8b062;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .line2017,
      .line2016,
      .line2014,
      .line2012,
      .line2013 {
        width: 16px;
        height: 109.5px;
        margin: 0 auto;
        margin-top: 8px;
        position: relative;

        .circular {
          width: 13px;
          height: 13px;
          border-radius: 50%;
          border: 1px solid #3880f4;
          position: relative;

          .dot {
            width: 4px;
            height: 4px;
            background: #3880f4;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .line {
          width: 1px;
          height: 88px;
          background: #3880f4;
          margin: 0 auto;
        }
        .dot {
          width: 4px;
          height: 4px;
          background: #3880f4;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .line2016,
      .line2014,
      .line2012 {
        .circular {
          border: 1px solid #f8b062;

          .dot {
            background: #f8b062;
          }
        }
        .line {
          background: #f8b062;
        }
        .dot {
          background: #f8b062;
        }
      }

      .line2015,
      .line2011 {
        width: 16px;
        height: 227.5px;
        margin: 0 auto;
        margin-top: 8px;
        position: relative;

        .circular {
          width: 13px;
          height: 13px;
          border-radius: 50%;
          border: 1px solid #3880f4;
          position: relative;

          .dot {
            width: 4px;
            height: 4px;
            background: #3880f4;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .line {
          width: 1px;
          height: 207px;
          background: #3880f4;
          margin: 0 auto;
        }
        .dot {
          width: 4px;
          height: 4px;
          background: #3880f4;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .month-all {
      width: 205px;
      height: 1970px;
      position: absolute;
      top: 0;
      right: 0;

      .month-all-list {
        margin-top: 15px;

        .month-list-item {
          width: 230px;
          height: 62px;
          margin-bottom: 56px;

          .month {
            height: 40px;
            font-size: 28px;
            font-weight: 600;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #272727;
            line-height: 40px;

            .enMonth {
              padding-right: 15px;
              display: inline-block;
              height: 40px;
              position: relative;

              &::after {
                content: "";
                width: 1px;
                height: 14px;
                background: #000;
                position: absolute;
                right: 0;
                top: 19px;
              }
            }

            .chMonth {
              display: inline-block;
              font-size: 16px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              margin-left: 15px;
            }
          }

          .month-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #999999;
            line-height: 20px;
            margin-top: 2px;
          }
        }
      }
    }
  }
}
</style>


